import React from 'react';
import { Box, Container, Typography, ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ScrollReveal } from '../../animations';

const CATEGORIES = [
  {
    key: 'umrah',
    title: 'Umrah',
    blurb: 'Makkah & Madina',
    image:
      'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?auto=format&fit=crop&w=800&q=70',
    category: 'Umrah',
  },
  {
    key: 'ziyarat',
    title: 'Ziyarat',
    blurb: 'Karbala, Syria & Holy Sites',
    image:
      'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=800&q=70',
    category: 'Ziyarat',
  },
  {
    key: 'international',
    title: 'International',
    blurb: 'Dubai, UK, Europe, Far East',
    image:
      'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=70',
    category: 'International',
  },
  {
    key: 'pakistan',
    title: 'Pakistan',
    blurb: 'Hunza, Swat & North',
    image:
      'https://images.unsplash.com/photo-1589802829985-817e51171b92?auto=format&fit=crop&w=800&q=70',
    category: 'Pakistan',
  },
  {
    key: 'local',
    title: 'Local',
    blurb: 'Murree & Weekends nearby',
    image:
      'https://images.unsplash.com/photo-1566438480900-0609be27a4be?auto=format&fit=crop&w=800&q=70',
    category: 'Pakistan',
  },
];

const DestinationCategories = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 7, md: 10 },
        background:
          'radial-gradient(1200px 400px at 10% 0%, rgba(31,111,120,0.08), transparent), #F7F8FA',
      }}
    >
      <Container maxWidth="lg">
        <ScrollReveal animation="fadeInUp">
          <Box sx={{ mb: 4, maxWidth: 520 }}>
            <Typography variant="h2" sx={{ mb: 1 }}>
              Explore by journey
            </Typography>
            <Typography color="text.secondary">
              One platform for every kind of trip — religious, leisure, or local.
            </Typography>
          </Box>
        </ScrollReveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(5, 1fr)',
            },
            gap: 2,
            maxWidth: '100%',
          }}
        >
          {CATEGORIES.map((cat, index) => (
            <ButtonBase
              key={cat.key}
              focusRipple
              onClick={() =>
                navigate(`/v2/packages?category=${cat.category}`)
              }
              component={motion.button}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: index * 0.06, duration: 0.45 }}
              whileHover={{ y: -4 }}
              sx={{
                display: 'block',
                textAlign: 'left',
                borderRadius: 3,
                overflow: 'hidden',
                position: 'relative',
                minHeight: { xs: 168, sm: 200, md: 220 },
                maxHeight: 280,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `url(${cat.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(180deg, transparent 20%, rgba(14,28,42,0.85) 100%)',
                }}
              />
              <Box sx={{ position: 'absolute', left: 16, right: 16, bottom: 16 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: '1.35rem',
                    fontWeight: 600,
                  }}
                >
                  {cat.title}
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>
                  {cat.blurb}
                </Typography>
              </Box>
            </ButtonBase>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default DestinationCategories;
